import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AllowRole from "../components/AllowRole";
import LoginPage from "../pages/LoginPage";
import AgendarPage from "../pages/AgendarPage";
import ViewPDFPage from "../pages/ViewPDFPage";


export default function MainRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route element={<AllowRole role={"1"} />}>
        <Route path="/1/agendar" element={<AgendarPage/>} />
      </Route>
      
      <Route path="/ver/pdf" element={<ViewPDFPage />} />
     

      <Route path="*" element={<Navigate to={"/login"} />} />
    </Routes>
  );
}
